export const locale = {
  close: 'Close',
  closeLabel: 'Close Modal',
  busyIndicator: 'Busy indicator',
};
